export default {
  notificacao (state) {
    return state.notificacao
  }
}



// WEBPACK FOOTER //
// ./src/store/notificacaoTabs/getters.js